var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"image-container",attrs:{"as":"span"}},[_c('img',_vm._b({ref:"resizableImg",attrs:{"alt":"","draggable":_vm.isDraggable,"data-drag-handle":_vm.isDraggable}},'img',_vm.node.attrs,false)),_c('i',{ref:"icon",staticClass:"ml-n3 resize-icon hidden",on:{"mousedown":_vm.onMouseDown}},[_vm._v("\n    resize\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }